export let content = {
    English: {
      heading:"Make a Visa Abroad?",
      subheading:"Get consultation with us now!",
      wa:"Contact Us Today!",
      lm:"Learn More",
    },  
    Indonesia:{
      heading:"Cari Visa Keluar Negeri?",
      subheading:"Dapatkan konsultasi visa dengan kami sekarang!",
      wa:"Hubungi hari ini!",
      lm:"Layanan Kami"
    }
  };